// ----- IMPORT -----
import React from 'react';
import './BlackKey.css';
// ------------------


const BlackKey = ({pos}) => {
    return(
        <div className={"blackkey pos" + pos}>
        </div>
    )
}

export default BlackKey;